import React from 'react';

import ResumeLandingPage from '../../js/pages/ResumePage/ResumeLandingPage';
import {getPublicCoachingData} from '../../../server/services/coaching';
import {cleanCoaches} from '../../js/util';
import {CoachAvailableStatuses} from '../../../lib/constants/coaching';

// Coaches whose Airtable Services include one of these are the people who
// actually review resumes — exactly who we want to put faces to.
const RESUME_REVIEW_SERVICES = ['Resume Review', 'Resume Review Call'];
const MAX_REVIEWERS = 5;

export default function Page({reviewers}) {
  return <ResumeLandingPage reviewers={reviewers} />;
}

export async function getServerSideProps() {
  let reviewers = [];

  try {
    const {coaches} = await getPublicCoachingData(CoachAvailableStatuses);
    reviewers = cleanCoaches(coaches)
      .filter((coach) => coach.Photo
        && coach.Services?.some((service) => RESUME_REVIEW_SERVICES.includes(service)))
      .sort((a, b) => (b.numHighlights || 0) - (a.numHighlights || 0))
      .slice(0, MAX_REVIEWERS)
      .map((coach) => {
        const role = Array.isArray(coach.Role) ? coach.Role.join(', ') : coach.Role;
        return {
          slug: coach.slug,
          name: coach.Name,
          // Title is the rich label (e.g. "Lead Talent Partner | ex-Netflix, Facebook");
          // fall back to the coarser Role tag if a coach has no Title.
          title: coach.Title || role || null,
          photo: coach.Photo,
        };
      });
  } catch (err) {
    // Faces are an enhancement — never block the page if coaching data fails.
    reviewers = [];
  }

  return {props: {reviewers}};
}
